import * as React from "react";

const IconArrowDropdownSmall: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="8" viewBox="0 0 6 8">
            <path
                fill="#666"
                fillRule="evenodd"
                d="M250.495359,12.3569464 C250.944112,12.3569464 251.168469,11.8364671 250.851839,11.5330341 L248.35648,9.14167863 C248.159359,8.95277379 247.840641,8.95277379 247.645609,9.14167863 L245.148161,11.5330341 C244.831531,11.8364671 245.055888,12.3569464 245.504641,12.3569464 L250.495359,12.3569464 Z M248.35648,16.8583214 L250.851839,14.4669659 C251.168469,14.1635329 250.944112,13.6430536 250.495359,13.6430536 L245.504641,13.6430536 C245.055888,13.6430536 244.831531,14.1635329 245.148161,14.4669659 L247.645609,16.8583214 C247.840641,17.0472262 248.159359,17.0472262 248.35648,16.8583214 Z"
                transform="translate(-245 -9)"
            />
        </svg>
    );
};

export default React.memo(IconArrowDropdownSmall);
